import { type Ref } from 'react';
import type { ListViewItemProps } from './list-view-item.types.ts';
import styles from './list-view-item.module.scss';

export function ListViewItem({ children, className, ref }: ListViewItemProps & { ref?: Ref<HTMLDivElement> }) {
  return (
    <div ref={ref} className={`${styles.item} ${className}`}>
      {children}
    </div>
  );
}
